// Need a new special case? See app/utils/custom-inflector-rules.js
import { pluralize } from 'ember-inflector';

export default function (count: number, singular: string, plural: string = pluralize(singular)) {
  if (count !== 1) {
    return plural;
  } else {
    return singular;
  }
}
